import { createContext, useContext, useReducer } from "react";
import { PartsID, PartsType } from "../data/consts";

const UPDATE_CATEGORY = "UPDATE_CATEGORY";
const UPDATE_PARTS = "UPDATE_PARTS";

//最初の状態
const initialState = {
  selectedCategory: PartsType.Hair,
  selectedParts: {
    [PartsType.Hair]: PartsID.DefaultHair,
    [PartsType.Eyebrow]: PartsID.None,
    [PartsType.Eyes]: PartsID.DefaultEyes,
    [PartsType.Nose]: PartsID.DefaultNose,
    [PartsType.Mouth]: PartsID.DefaultMouth,
    [PartsType.Glasses]: PartsID.None,
    [PartsType.Other]: PartsID.None,
  },
};

//context作成
const AppContext = createContext(initialState)

//Reducer
const appReducer = (state, action) => {
  //(state, action)=({selectedCategory, selectedParts}, {type, payload})が入っている
  //カテゴリー更新なら{type, payload}= {"UPDATE_CATEGORY", categoryId}
  //PARTS更新なら{type, payload}= {"UPDATE_PARTS", {categoryId, partsId}}
  const { type, payload } = action;
  switch (type) {
    case UPDATE_CATEGORY: {
      return {
        ...state,
        selectedCategory: payload,
      };
    }
    case UPDATE_PARTS: {
      const { categoryId, partsId } = payload;
      const { selectedParts } = state;
      //selectedCategoryはそのままで
      //selectedParts: {[PartsType.Hair]: PartsID.DefaultHair,...で更新
      //[PartsType.Hair]: PartsID.DefaultHair= [categoryId]: partsIdになる
      return {
        ...state,
        selectedParts: {...selectedParts, [categoryId]: partsId},
      };
    }
    default: {
      return state;
    }
  }
}

//provider作成
const AppProvider = ({children}) => {
  const [state, dispatch] = useReducer(appReducer, initialState);
  const value = {state, dispatch};
  return(
    <AppContext.Provider value= {value}>
      {children}
    </AppContext.Provider>
  )
}

//useContext作成
//selectedPartsを返す
const useSelectedParts = () => {
  const { state} = useContext(AppContext);
  if (state  === undefined){
    throw new Error("エラー発生中")
  }
  //context内にはselectedCategory, selectedPartsがあるのでselectedPartsを取り出す
  const { selectedParts } = state;
  return selectedParts;
}

//selectedCategoryを返す
const useSelectedCategory = () => {
  const {state}  = useContext(AppContext);
  if (state  === undefined){
    throw new Error("エラー発生中")
  }
  //context内にはselectedCategory, selectedPartsがあるのでselectedCategoryを取り出す
  const { selectedCategory } = state;
  return selectedCategory;
}

//更新作業
//dispatchを使うために取り出す！dispatchの中身がなければエラーを吐き出す
const useDispatch = () => {
  const { dispatch } = useContext(AppContext)
  if( dispatch === undefined){
    throw new Error("エラー発生中")
  }
  return dispatch;
}

const updateCategory = (categoryId) => {
  return{
    type: UPDATE_CATEGORY,
    payload: categoryId
  };
}

//上のdispatchに包んで送る
const updateParts = ({categoryId, partsId }) => {
  return {
    type: UPDATE_PARTS,
    payload: {
      categoryId,
      partsId,
    },
  };
}


export {
  AppProvider,
  useSelectedParts,
  useSelectedCategory,
  useDispatch,
  updateCategory,
  updateParts,
}
